import { SelectData } from './select.model'

const optionToData = (option: HTMLOptionElement): SelectData => ({
	label: option.textContent || '',
	value: option.value,
	description: option.dataset.description || undefined,
})

export const getDataFromNativeSelect = (select: HTMLSelectElement): SelectData[] => {
	const options = select.querySelectorAll<HTMLOptionElement>('option')
	return Array.from(options).map(optionToData)
}

export const getDefaultValueFromNativeSelect = (select: HTMLSelectElement): SelectData | SelectData[] => {
	const options = select.querySelectorAll<HTMLOptionElement>('option[selected]')
	const optionsArray = Array.from(options).map(optionToData)
	const firstOption = optionsArray.filter((item) => item.value === select.value)[0]
	return select.multiple ? optionsArray : { label: firstOption ? firstOption.label : '', value: select.value }
}
